import { render, staticRenderFns } from "./NotificationDetailView.vue?vue&type=template&id=51a15d5d&scoped=true"
import script from "./NotificationDetailView.vue?vue&type=script&lang=js"
export * from "./NotificationDetailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a15d5d",
  null
  
)

export default component.exports